import React, { ReactNode } from 'react';

import { QueryProvider } from './QueryProvider';

interface ProvidersProps {
  children: ReactNode;
}

export const Providers: React.FC<ProvidersProps> = ({ children }) => {
  return <QueryProvider>{children}</QueryProvider>;
};
